export default "__VITE_ASSET__BxLnaLpy__"